<template>
  <b-row>
    <b-col class="text-center text-md-left">
      <div v-if="withTinCheck && (!tinResponse.success || tinResponse.success === false) && (this.registerConfig.allowManualOnFailure === false || (this.registerConfig.allowManualOnFailure === true && failure !== true))">
        <p v-translate v-show="!registerCompanyOnly">At the moment we work exclusively with legally established companies so before start, please, enter your company TIN below.</p>
        <p v-translate v-show="registerCompanyOnly">Due to some changes to ensure the best service we work (for now) exclusively with legally established companies so before start operating, please, enter your company TIN below.</p>
        <form @submit.prevent="checkTin()" class="mt-5">
          <b-row>
            <b-col>
              <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'document_types').length > 0">
                <b-form-select id="company-tin-type" style="font-size: 2rem" size="lg" v-model="company.tin_type" :options="accountingCatalogs.filter(x => x.catalog === 'document_types').map(x => { return {text: x.name, value: x.id}})" class="form-control mb-3">
                  <template #first>
                    <option :value="null" v-translate>Document Type</option>
                  </template>
                </b-form-select>
              </b-form-group>
              <b-form-group>
                <input-facade v-if="$appConfig.tinMask[tinCountry]" :formatter="toUpper" :mask="$appConfig.tinMask[tinCountry] || ''" v-model="company.tin" class="form-control" style="font-size: 2rem" size="lg" id="company-tin" :disabled="accountingCatalogs.filter(x => x.catalog === 'document_types').length > 0 && !company.tin_type" :placeholder="accountingCatalogs.findIndex(x => x.catalog === 'document_types' && x.external_id === company.tin_type) !== -1 ? accountingCatalogs.find(x => x.catalog === 'document_types' && x.external_id === company.tin_type).name : $gettext('Document Number')" required :class="preCheckTin !== null ? (preCheckTin ? 'is-valid' : 'is-invalid') : ''" />
                <b-input v-else class="form-control" style="font-size: 2rem" size="lg" id="company-tin" :disabled="accountingCatalogs.filter(x => x.catalog === 'document_types').length > 0 && !company.tin_type" :placeholder="accountingCatalogs.findIndex(x => x.catalog === 'document_types' && x.external_id === company.tin_type) !== -1 ? accountingCatalogs.find(x => x.catalog === 'document_types' && x.external_id === company.tin_type).name : $gettext('Document Number')" v-model="company.tin" required :state="preCheckTin" />
              </b-form-group>
              <b-button variant="primary" type="submit" size="lg" :disabled="preCheckTin !== null && preCheckTin !== true || (accountingCatalogs.filter(x => x.catalog === 'document_types').length > 0 && !company.tin_type || !company.tin)">
                  <b-spinner small v-if="sending"></b-spinner>
                  <strong v-translate>Search</strong>
              </b-button>
            </b-col>
          </b-row>
        </form>
      </div>
      <div v-else-if="!withTinCheck || (tinResponse.success || tinResponse.success === true) || (withTinCheck && this.registerConfig.allowManualOnFailure === true && failure === true)">
        <b-alert variant="info" show class="mb-3 py-3" v-if="withTinCheck && (tinResponse.success || tinResponse.success === true)">
            <h4 v-translate>Available Company Info</h4>
            <h3>{{company.business_name}}</h3>
            <h5 v-if="$appConfig.tinMask[tinCountry]"><translate>TIN</translate> {{company.tin | facade($appConfig.tinMask[tinCountry])}}</h5>
            <h5 v-else><translate>TIN</translate> {{company.tin}}</h5>
            <p>
              {{company.address}}
            </p>
            <a href="#" @click.prevent="resetData" v-translate>This is not your company? Search for TIN again</a>
        </b-alert>
        <b-alert variant="info" show class="mb-3 py-3" v-else-if="withTinCheck && this.registerConfig.allowManualOnFailure === true && failure === true">
            <h4 v-translate>Oops! We couldn't find and fetch your company info with the TIN you provided</h4>
            <h5 v-if="$appConfig.tinMask[tinCountry]"><translate>TIN</translate> {{company.tin | facade($appConfig.tinMask[tinCountry])}}</h5>
            <h5 v-else><translate>TIN</translate> {{company.tin}}</h5>
            <p v-translate>Is it OK? You may search for it again clicking the link below or you can manually fill all your company info on the following form</p>
            <a href="#" @click.prevent="resetData" v-translate>Search for TIN again</a>
        </b-alert>
        <form @submit.prevent="register()" class="form form--login grid mb-3" v-if="company.is_created === false">
          <div v-if="withTinCheck && failure === false">
            <h4 class="mt-4" v-translate>Extra Info <small class="text-danger">(required)</small></h4>
            <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'customer_types').length > 0">
              <b-form-select size="lg" v-model="company.entity_type" :options="accountingCatalogs.filter(x => x.catalog === 'customer_types').map(x => { return {text: x.name, value: x.id}})" class="form-control" required>
                <template #first>
                  <option :value="null" v-translate>Client Type</option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'tax_conditions').length > 0">
              <b-form-select size="lg" v-model="company.contributor_type" :options="accountingCatalogs.filter(x => x.catalog === 'tax_conditions').map(x => { return {text: x.name, value: x.id}})" class="form-control" required>
                <template #first>
                  <option :value="null" v-translate>Contributor Type</option>
                </template>
              </b-form-select>
            </b-form-group>
            <div class="form-group">
              <input class="form-control" id="company__business_name" :placeholder="$gettext('Fiscal/Legal Name')" v-model="company.business_name" v-if="!company.business_name" required>
            </div>
            <div class="form-group">
              <input class="form-control" id="company__name" :placeholder="$gettext('Brand/Commercial Name')" v-model="company.name" required>
            </div>
            <div class="form-group">
              <b-textarea class="form-control" id="company__address" :placeholder="$gettext('Fiscal/Legal Address')" v-model="company.address" v-if="!company.address" required />
            </div>
            <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'states').length > 0">
              <b-form-select size="lg" v-model="company.address_state" :options="accountingCatalogs.filter(x => x.catalog === 'states').map(x => { return {text: x.name, value: x.id}})" class="form-control" required>
                <template #first>
                  <option :value="null" v-translate>Province/State</option>
                </template>
              </b-form-select>
            </b-form-group>
          </div>
          <div v-else>
            <p class="mt-4" v-translate v-show="!registerCompanyOnly && !failure">At the moment we work exclusively with legally established companies so before start, please, enter your company information below.</p>
            <p class="mt-4" v-translate v-show="registerCompanyOnly && !failure">Due to some changes to ensure the best service we work (for now) exclusively with legally established companies so before start operating, please, enter your company information below.</p>
            <h4 class="mt-4" v-translate>Basic Info <small class="text-danger">(required)</small></h4>
            <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'document_types').length > 0">
              <b-form-select id="company-tin-type" v-model="company.tin_type" :options="accountingCatalogs.filter(x => x.catalog === 'document_types').map(x => { return {text: x.name, value: x.id}})" class="form-control" required :disabled="!!withTinCheck">
                <template #first>
                  <option :value="null" v-translate>Document Type</option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group>
              <input-facade v-if="$appConfig.tinMask[tinCountry]" :mask="$appConfig.tinMask[tinCountry] || ''" :formatter="toUpper" v-model="company.tin" class="form-control" id="company-tin" :disabled="!!withTinCheck" required :class="preCheckTin !== null ? (preCheckTin ? 'is-valid' : 'is-invalid') : ''" />
              <b-input v-else class="form-control" id="company-tin" :disabled="!!withTinCheck" :placeholder="accountingCatalogs.findIndex(x => x.catalog === 'document_types' && x.external_id === company.tin_type) !== -1 ? accountingCatalogs.find(x => x.catalog === 'document_types' && x.external_id === company.tin_type).name : $gettext('Document Number')" v-model="company.tin" required :state="preCheckTin" />
            </b-form-group>
            <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'customer_types').length > 0">
              <b-form-select size="lg" v-model="company.entity_type" :options="accountingCatalogs.filter(x => x.catalog === 'customer_types').map(x => { return {text: x.name, value: x.id}})" class="form-control" required>
                <template #first>
                  <option :value="null" v-translate>Client Type</option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'tax_conditions').length > 0">
              <b-form-select size="lg" v-model="company.contributor_type" :options="accountingCatalogs.filter(x => x.catalog === 'tax_conditions').map(x => { return {text: x.name, value: x.id}})" class="form-control" required>
                <template #first>
                  <option :value="null" v-translate>Contributor Type</option>
                </template>
              </b-form-select>
            </b-form-group>
            <div class="form-group">
              <input class="form-control" id="company__business_name" :placeholder="$gettext('Fiscal/Legal Name')" v-model="company.business_name" required>
            </div>
            <div class="form-group">
              <input class="form-control" id="company__name" :placeholder="$gettext('Brand/Commercial Name')" v-model="company.name" required>
            </div>
            <div class="form-group">
              <b-textarea class="form-control" id="company__address" :placeholder="$gettext('Fiscal/Legal Address')" v-model="company.address" required />
            </div>
            <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'states').length > 0">
              <b-form-select size="lg" v-model="company.address_state" :options="accountingCatalogs.filter(x => x.catalog === 'states').map(x => { return {text: x.name, value: x.id}})" class="form-control mb-3" required>
                <template #first>
                  <option :value="null" v-translate>Province/State</option>
                </template>
              </b-form-select>
            </b-form-group>
          </div>

          <h5 class="mt-4" v-translate>Commercial Contact <small class="text-danger">(required)</small></h5>
          <div class="form-group">
            <input type="text" :placeholder="$gettext('Name')" class="form-control" id="company__commercial__name" v-model="company.contact_name" required>
          </div>
          <div class="form-group">
            <input type="text" :placeholder="$gettext('Phone')" class="form-control" id="company__commercial__phone" v-model="company.phone" required>
          </div>
          <div class="form-group">
            <input type="email" :placeholder="$gettext('E-mail')" class="form-control" id="company__commercial__email" v-model="company.email" required>
          </div>

          <div v-if="!registerCompanyOnly">
            <h5 class="mt-4" v-translate>New User <small class="text-danger">(required)</small></h5>
            <p v-translate>This is the information you will need to log in into the system and to administrate your company users.</p>
            <div class="form-group">
              <input type="text" :placeholder="$gettext('Your Name')" class="form-control" id="login__name" v-model="user.name" required>
            </div>
            <div class="form-group label-floating">
              <input type="email" :placeholder="$gettext('E-mail')" class="form-control" id="login__email" v-model="user.email" required>
            </div>
            <div class="form-group">
              <password ref="pwd_check" :min="passwordMinLength" :placeholder="$gettext('Password')" v-model="user.password" inputClass="form-control" @score="newPasswordScore = $event" :min-score="passwordMinScore" />
              <b-form-text id="inputLiveHelp" v-translate="{minLength: passwordMinLength}">%{minLength} characters minimum, must contain upper and lower case letters, numbers and symbols</b-form-text>
            </div>
          </div>

          <b-row v-if="$store.getters.universe.terms || $store.getters.universe.privacy">
            <b-col>
              <div class="form-group mt-4">
                <b-form-checkbox v-model="user.terms" required>
                  <span v-if="$store.getters.universe.terms && $store.getters.universe.privacy" v-translate="{terms: this.$store.getters.universe.terms, privacy: this.$store.getters.universe.privacy}">I've read and agree to the <a href="%{terms}" target="_blank">Terms and Conditions</a> and the <a href="%{privacy}" target="_blank">Privacy Policy</a></span>
                  <span v-if="$store.getters.universe.terms && !$store.getters.universe.privacy" v-translate="{terms: this.$store.getters.universe.terms}">I've read and agree to the <a href="%{terms}" target="_blank">Terms and Conditions</a></span>
                  <span v-if="!$store.getters.universe.terms && $store.getters.universe.privacy" v-translate="{privacy: this.$store.getters.universe.privacy}">I've read and agree to the <a href="%{privacy}" target="_blank">Privacy Policy</a></span>
                </b-form-checkbox>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" order="1" order-md="1" class="text-center mt-4">
              <button type="submit" class="btn btn-lg btn-primary" :disabled="!formCompleted">
                <b-spinner small v-if="sending"></b-spinner>
                <strong v-show="!registerCompanyOnly" v-translate>Sign up</strong>
                <strong v-show="registerCompanyOnly" v-translate>Register Your Company</strong>
              </button>
            </b-col>
            <b-col md="12" order="12" order-md="2" class="text-center" v-show="!registerCompanyOnly">
              <p class="forgot">
                <router-link to="password/reset" v-translate>Forgot password?</router-link>
              </p>
            </b-col>
          </b-row>
        </form>
        <b-alert variant="warning" show v-else>
            <h2 v-translate>The company already exists into our system</h2>
            <h4 v-translate="{siteName: this.siteName}">You must contact the person on your company who administer the %{siteName} Dashboard and ask them for your user creation.</h4>
        </b-alert>
      </div>
    </b-col>
    <div class="overlay" v-if="sending"></div>
    <span class="d-none" v-translate>Your Name</span>
    <translate class="d-none">TIN</translate>
    <translate class="d-none">Brand/Commercial Name</translate>
    <translate class="d-none">Fiscal/Legal Name</translate>
    <translate class="d-none">Fiscal/Legal Address</translate>
    <translate class="d-none" translate-context="fem">Other</translate>
  </b-row>
</template>
<script>
import L from 'leaflet'
import LeafletMap from '@/components/LeafletMap'
import Password from '@/components/Password'
import checkTinLocal from '@/common/checkTinLocal'

export default {
  name: 'RegisterPage',
  title() {
    return this.$gettext('Create a new account')
  },
  components: {
    LeafletMap,
    Password
  },
  props: {
    registerConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // registerConfig: this.$frontConfig.register,
      country: this.$cookies.get('country'),
      countryConfirmed: true,
      accountingCatalogs: [],
      regionsSelect: [],
      regionId: null,
      regionConfirmed: true,
      industries: [],
      techs: [],
      tinResponse: {},
      newBillingDetailsEmail: '',
      failure: false,
      company: {
        name: '',
        tin_type: null,
        tin: '',
        entity_type: null,
        contributor_type: null,
        address: '',
        address_state: null,
        contact_name: '',
        phone: '',
        email: '',
        billing_details: {
          name: '',
          last_name: '',
          phone: '',
          emails: []
        },
        industriesSetting: null,
        industries: [],
        e_commerce_techs: [],
        is_created: false
      },
      user: {
        name: '',
        email: '',
        password: '',
        terms: false
      },
      passwordMinLength: 12,
      passwordMinScore: 100,
      newPasswordScore: 0,
      sending: false,
      map: null,
      countryHasSelfService: false,
      theAreas: {}
    }
  },
  computed: {
    formCompleted() {
      // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (this.registerCompanyOnly) {
        return this.company.tin &&
          this.company.business_name &&
          this.company.name &&
          this.company.address &&
          this.company.contact_name &&
          this.company.phone &&
          this.company.email &&
          this.user.terms
      } else {
        return this.company.tin &&
          this.company.business_name &&
          this.company.name &&
          this.company.address &&
          this.company.contact_name &&
          this.company.phone &&
          this.company.email &&
          this.user.name &&
          this.user.email &&
          this.user.password &&
          this.user.password.length >= this.passwordMinLength &&
          this.newPasswordScore >= this.passwordMinScore &&
          this.user.terms
      }
    },
    registerCompanyOnly() {
      return this.$store.getters.profile && this.$store.getters.profile.company_id === null
    },
    withTinCheck() {
      return this.registerConfig && this.registerConfig.checkTin === true && (!this.tinResponse.success || this.tinResponse.success !== true)
    },
    preCheckTin() {
      if (this.registerConfig.preCheckTin && this.company.tin.length > 0) {
        const match = this.company.tin.match(new RegExp((this.registerConfig.preCheckTin), 'gi'))

        if (!match) {
          return false
        } else {
          return true
        }
      } else {
        return null
      }
    },
    showAllCountries() {
      return this.$route.query.all
    },
    tinType() {
      return this.company.tin_type ? this.accountingCatalogs.find(x => x.id === this.company.tin_type).name : null
    },
    tinCountry() {
      return window.countries.find(x => x.iso_code === this.country).language.split('_')[1]
    }
  },
  watch: {
    regionId(val) {
      if (val) {
        this.theAreas = this.geoJsons.find(x => x.id === val).geoJsonObject
      } else {
        this.$refs.fullMap.geoJson = null
      }
    }
  },
  created() {
    this.fetchCountries()
    this.fetchAccountingStuff()
  },
  mounted() {
    if (this.$store.getters.universe.restrictRegisterToCountry) {
      this.countryConfirmed = true
    }
  },
  methods: {
    mapReady() {
      this.map = this.$refs.fullMap.$refs.theMap.mapObject
      setTimeout(() => {
        this.map.invalidateSize()
        this.$refs.fullMap.geoJson = this.theAreas
        let geoJSON = L.geoJson(this.$refs.fullMap.geoJson.map(x => x.geoJson))
        setTimeout(() => {
          this.$refs.fullMap.$refs.theMap.mapObject.fitBounds(geoJSON.getBounds())
        }, 500)
      }, 100)
    },
    toUpper(v) {
      return v.masked.toUpperCase()
    },
    setNewCountry() {
      if (this.country !== null) {
        this.$frontConfig = this.countries.find(x => x.iso_code === this.country).front_config || null
        this.$cookies.set('country', this.country, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$cookies.set('phonePrefix', this.$frontConfig.i18n.phonePrefix, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$emit('countryChanged')
      }
      if (this.$frontConfig) {
        this.$language.current = this.$frontConfig.i18n.lang || 'en_US'
        let moment = this.$frontConfig.i18n.moment || 'en'
        this.moment.locale(moment)
      }
      this.resetData()
      if (this.$frontConfig.selfServiceRegionIds) {
        this.countryHasSelfService = true
        this.fetchRegions()
      } else {
        this.countryHasSelfService = false
        this.setNewRegion()
      }
    },
    fetchRegions() {
      let params = {
        sort: [
          {
            key: 'name',
            direction: 'asc'
          }
        ],
        includes: [
          'areas'
        ],
        filter_groups: [
          {
            filters: [
              ['id', 'in', this.$frontConfig.selfServiceRegionIds]
            ]
          }
        ]
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'countries/' + this.country + '/regions', { params })
        .then(response => {
          this.regions = response.body.data
          this.regionsSelect = this.regions.map(x => {
            if (this.$frontConfig.selfServiceRegionIds && this.$frontConfig.selfServiceRegionIds.indexOf(x.id) !== -1) {
              return {
                value: x.id,
                text: x.name
              }
            }
          }).filter(Boolean)
          this.geoJsons = this.regions.map(x => {
            if (this.$frontConfig.selfServiceRegionIds && this.$frontConfig.selfServiceRegionIds.indexOf(x.id) !== -1) {
              return {
                id: x.id,
                geoJsonObject: this.makeGeoJson(x.areas)
              }
            }
          })
          console.log(this.geoJsons)
        })
    },
    makeGeoJson(areas) {
      // let output = {
      //   type: 'FeatureCollection',
      //   properties: {
      //     'stroke': '#555555',
      //     'stroke-width': 0,
      //     'stroke-opacity': 1,
      //     'fill': '#ff0000',
      //     'fill-opacity': 0.5
      //   },
      //   features: []
      // }
      let output = []
      for (let i = 0; i < areas.length; i++) {
        // const poly = areas[i].area.coordinates[0]
        if (!areas[i].is_dangerous) {
          output.push(
            {
              geoJson: {
                type: 'Feature',
                properties: {
                  'stroke': '#555555',
                  'stroke-width': 0,
                  'stroke-opacity': 1,
                  'fill': '#ff0000',
                  'fill-opacity': 0.5
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: areas[i].area.coordinates
                }
              },
              objectStyle: {
                weight: 1,
                stroke: areas[i].is_dangerous ? '#ff0000' : '#3388ff',
                color: areas[i].is_dangerous ? '#ff0000' : '#3388ff',
                strokeWidth: 1,
                strokeOpacity: 0.7,
                fillColor: areas[i].is_dangerous ? '#ff0000' : '#3388ff',
                fillOpacity: 0.5
              }
            }
          )
        }

        // output.features[0].geometry.coordinates.push(areas[i].area.coordinates)
      }
      return output
    },
    setNewRegion() {
      this.regionConfirmed = true
    },
    fetchAccountingStuff() {
      let params = {
        sort: [{
          key: 'name',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['country_iso_code', 'eq', this.country],
              ['catalog', 'in', ['customer_types', 'document_types', 'states', 'tax_conditions']]
            ]
          }
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'accounting-catalogs', {params: params})
        .then(response => {
          this.accountingCatalogs = response.body.data
        })
    },
    async checkTin() {
      this.sending = true
      if (this.registerConfig.endpoint) {
        return this.$http.get(this.$appConfig.api.baseUrl + this.registerConfig.endpoint.replace('{tin}', this.company.tin.replace(/[^a-zA-Z0-9]/g, '')))
          .then(response => {
            this.company = {...this.company, ...this.remapResponse(response.body, this.registerConfig.mapResponse)}
            Object.keys(this.company).forEach(key => {
              if (key.indexOf('raw') === -1) {
                this.company[key] = this.company[key] !== '-' && this.company[key] !== '' ? this.company[key] : null
              }
            })

            this.tinResponse['success'] = true
            this.sending = false
          }, error => {
            this.sending = false
            if (this.registerConfig.allowManualOnFailure === true) {
              this.failure = true
              this.$root.$children[0].$refs.simplert.justCloseSimplert()
            } else {
              let message = ''
              if (error.status === 404) {
                message = this.$gettext('The TIN has not been found or it\'s invalid. Please, check the number and try again')
              } else {
                message = this.$gettext('There were an error. Please, try again.')
              }
              let obj = {
                title: 'ERROR',
                message: message,
                type: 'error',
                customCloseBtnText: this.$gettext('Close')
              }
              this.$root.$children[0].$refs.simplert.openSimplert(obj)
            }
          })
      } else {
        console.log(checkTinLocal, checkTinLocal[this.tinCountry])
        if (await checkTinLocal[this.tinCountry].doCheck(this.company.tin)) {
          this.tinResponse['success'] = true
          this.failure = true
          this.sending = false
        } else {
          this.sending = false
          if (this.registerConfig.allowManualOnFailure === true) {
            this.failure = true
          } else {
            let message = this.$gettext('The TIN has not been found or it\'s invalid. Please, check the number and try again')
            let obj = {
              title: 'ERROR',
              message: message,
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
          }
        }
      }
    },
    remapResponse(o, r) {
      o = this.flattenObject(o)
      return Object.keys(o).map((key) => ({ [r[key] || key]: o[key] })).reduce((a, b) => Object.assign({}, a, b))
    },
    flattenObject(objectOrArray, prefix = '', formatter = (k) => (k)) {
      const nestedFormatter = (k) => ('.' + k)
      const nestElement = (prev, value, key) => (
        (value && typeof value === 'object')
          ? { ...prev, ...this.flattenObject(value, `${prefix}${formatter(key)}`, nestedFormatter) }
          : { ...prev, ...{ [`${prefix}${formatter(key)}`]: value } })

      return Array.isArray(objectOrArray)
        ? objectOrArray.reduce(nestElement, {})
        : Object.keys(objectOrArray).reduce(
          (prev, element) => nestElement(prev, objectOrArray[element], element),
          {},
        )
    },
    register() {
      this.company.country_iso_code = this.$cookies.get('country')
      if (this.failure) {
        this.company.meta = {
          manualData: true
        }
      }
      this.company.industries = [this.company.industriesSetting]
      let company = JSON.parse(JSON.stringify(this.company))

      // HACK TODO: REMOVE WHEN BACKEND REGEX FOR CL IS FIXED
      if (company.country_iso_code === 'CL' || this.country === 'CL') {
        company.tin = company.tin.replace(/(.{1}$)/, '-$1')
      }
      if (this.registerCompanyOnly) {
        this.sending = true
        company.user_id = this.$store.getters.profile.id
        this.$http.post(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/self-service/companies', company)
          .then(response => {
            window.location.href = window.location.origin
          }, error => {
            this.sending = false
            let message = ''
            if (error.status === 422) {
              for (let i = 0; i < error.body.errors.length; i++) {
                message += '- ' + error.body.errors[i].detail + '<br>'
              }
            } else if (error.status === 409) {
              // this.company.is_created = true
              message = this.$gettext('The company already exists into our system') + '. ' + this.$gettextInterpolate(this.$gettext('You must contact the person on your company who administer the %{siteName} Dashboard and ask them for your user creation.'), {siteName: this.siteName})
            } else {
              message = this.$gettext('There were an error creating the company. Please, try again.')
            }
            let obj = {
              title: 'ERROR',
              message: message,
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
          })
      } else {
        if (this.$refs.pwd_check.has_length && this.$refs.pwd_check.pwd_score >= 40) {
          this.sending = true
          this.$http.post(this.$appConfig.api.baseUrl + 'users/', {
            name: this.user.name,
            email: this.user.email,
            password: this.$refs.pwd_check.password,
            country_iso_code: this.$cookies.get('country'),
            terms: this.user.terms
          }).then(response => {
            this.$http.post(this.$appConfig.api.baseUrl + 'users/' + response.body.id + '/self-service/companies', company)
              .then(response => {
                this.$router.push('/login?r=true')
              })
          }, error => {
            this.sending = false
            let message = ''
            if (error.status === 422) {
              for (let i = 0; i < error.body.errors.length; i++) {
                message += '- ' + error.body.errors[i].detail + '<br>'
              }
            } else if (error.status === 404) {
              message = this.$gettext('Sorry! We still don\'t bring services in your country :(')
            } else {
              message = this.$gettext('The email is already registered<br><br>Please <a href=/login>log in</a> with your previous credentials<br>or<br><a href=/password/reset>click here</a> if you forgot your password') // error.body.message
            }
            let obj = {
              title: 'ERROR',
              message: message,
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
          })
        }
      }
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.countryConfirmed = true
      this.fetchCountries()
      this.fetchAccountingStuff()
    }
  }
}

</script>

<style lang="scss">
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .5);
  top: 0;
  left: 0;
  z-index: 15;
}
</style>
